import React, { useState, useMemo, useEffect } from "react";
import Sidebar from '../components/Sidebar';
import { getMenuStructure, reports } from '../data/reportsData';
import ReportContent from '../components/ReportContent';

export default function Dashboard() {
    // --- États pour l'authentification et les rôles ---
    const [userRoles, setUserRoles] = useState([]); 
    const [userName, setUserName] = useState("Chargement..."); 
    
    // --- États de l'interface ---
    const [activeReportId, setActiveReportId] = useState("accueil");
    const [isLoading, setIsLoading] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true); 
    const [isKpiOpen, setIsKpiOpen] = useState(true); 


    const menuStructure = useMemo(() => {
        return getMenuStructure(userRoles);
    }, [userRoles]);

    // --- Calcul du rapport actif ---
    const activeReport = useMemo(() => 
        reports.find((r) => r.id === activeReportId) || reports[0], 
        [activeReportId]
    );

    // --- Appel API Check-Auth ---
    useEffect(() => {
        async function fetchUserDetails() {
            try {
                const response = await fetch("/api/check-auth");
                
                if (response.ok) {
                    const data = await response.json();
                    
                    // Nom
                    setUserName(data.email || "Utilisateur");


                    if (data.roles && Array.isArray(data.roles)) {
                        setUserRoles(data.roles);
                    } else {
                        // API renvoie vide
                        setUserRoles(["authenticated"]);
                    }
                }
            } catch (error) {
                console.error("Erreur lors de la récupération des droits:", error);
                setUserName("Erreur connexion");
                setUserRoles(["authenticated"]); 
            }
        }
        
        fetchUserDetails();
    }, []); 

    // --- Gestionnaires d'événements ---
    const handleReportClick = (id) => {
        if (id !== activeReportId) {
            setActiveReportId(id);
            setIsLoading(true);
        }
    };

    const handleLogout = () => {
        window.location.replace("/.auth/logout");
    };

    const toggleKpi = () => setIsKpiOpen(!isKpiOpen);
    const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

return (
        <div className="flex h-screen bg-gray-100 overflow-hidden">

            {/* Sidebar */}
            <Sidebar
                menuStructure={menuStructure}
                activeReportId={activeReportId}
                isSidebarOpen={isSidebarOpen}
                isKpiOpen={isKpiOpen}
                toggleSidebar={toggleSidebar}
                toggleKpi={toggleKpi}
                handleReportClick={handleReportClick}
                handleLogout={handleLogout}
                userName={userName}
                userRoles={userRoles} 
            />

            {/* Contenu */}
            <div className="flex-1 flex flex-col h-full relative transition-all duration-300">                
                <main className="flex-1 h-full p-4 overflow-hidden">
                    <ReportContent
                        activeReport={activeReport}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                    />
                </main>
            </div>
        </div>
    );
}
